import * as Yup from 'yup';

export const createTestGroupSchema = {
  initialValues: {
    name: '',
    description: '',
    prefix: '',
    retainMonths: '',
    additionalFields: [],
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().optional(),
    prefix: Yup.string().optional(),
    retainMonths: Yup.number()
      .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
      .min(1)
      .max(12)
      .optional(),
    additionalFields: Yup.mixed().optional(),
  }),
};
